var layout_default = {
  "layout": "rQ3kt",
  "cell": "-VdaQ"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
